import React from 'react';

import { Loading } from 'lib/ui';

const LoadingPage = props => {
  return <Loading text="Trwa ładowanie..." />;
};

export { LoadingPage };
